import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from "../../../../layouts/Layout";
import * as PR from "../../../../prime-react/index";
import { createNews } from "../../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { ErrorMessage, useToast } from '../../../../context/ToastContext';
import { isEmpty } from 'lodash';
import { dompurifyText, trimFileName } from '../../../../utils/reuse';

const creatNewsError = 'create_news_error'

const PreviewNews = () => {
  const { showToast, clearError } = useToast();
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, seLoading] = useState(false);
  const sessionData = useSelector((state) => state.auth.sessionData);
  const headers = {
    sessionid: sessionData.sessionId,
    "Content-Type": "multipart/form-data",
  };
  useEffect(() => {
    if (isEmpty(state?.payload)) {
      navigate("/news");
    } 
  }, [navigate, state?.payload]);
  const newsData = state?.payload;
  const attachments = state?.attachments; 
  const deletedAttachments = state?.deletedAttachments;
  const coverImage = state?.coverImage;
  const { title, description, newsType, keywords, categoryName } = newsData;
  const todayDate = new Date().toLocaleDateString();
  const files = attachments;
  const handlePublish = () => {
    seLoading(true);
    clearError(creatNewsError)
    const formData = new FormData();
    if(deletedAttachments?.length>0){
      newsData.deletedAttachments = deletedAttachments.filter(d => d !== undefined);
    }    
    formData.append("data", JSON.stringify(newsData));
    attachments?.forEach((file) => {
      formData.append("attachments", file);
    });
    if(coverImage){
      formData.append("image", coverImage);
    }
    createNews(formData, headers, dispatch, (response) => {
      seLoading(false);
      if (response.result === "SUCCESS") {
        showToast('success', 'News Item updated successfully.');
        navigate("/news");
      } else {
          const error = response.error;
          showToast(error.severity, error?.errorMsg || error?.summary, creatNewsError);
          setTimeout(() => {
            clearError(creatNewsError)
          }, 5000)
      }
    });
  };

  const getImageSource = (image) => {
    if (typeof image === 'string') {
      return image;
    } else if (image instanceof File) {
      return URL.createObjectURL(image);
    }
    return null;
  };
  const goBack = () => {
    if(state?.queryParams?.id){
      navigate(`/edit-details?id=${state?.queryParams?.id}`, {state: {...state}})
    } else {
      navigate('/create-news', {state: {formvalues: state?.formvalues}});
    }
  }

  return (
    <Layout backBtn={"news"} backBtnLabel="News">
      <section className="news-tab news-details-section general-news-section">
        <div className="flex align-items-center justify-content-between mb-4">
          <div className="left">
            <h1>Preview News Item</h1>
          </div>
          <div className='right flex gap-2'>
            <PR.Button label="Publish" className="action-buttons save-button" disabled={loading} onClick={handlePublish} />
          </div>
        </div>
        <div className="grid">
          <div className="col-12">
            <div className='new-list-section'>
              <div className='list-wrapper'>
                <h2>{title}</h2>
                <div className="news-list">
                  <div className="card">
                    <div className="col-12 p-0">
                      <div className='flex align-items-center justify-content-between mb-4'>
                        {newsType === 'sportingsanctions' ? (
                          <>
                            <ul className='chips-ul'>
                              {keywords && keywords?.split(',').map((keyword, index) =>(
                                <li key={index}>{keyword}</li>
                              ))}
                            </ul>
                            <ul className="flex list-none align-items-center gap-4 mb-0">
                              <li><i className="pi pi-calendar"></i> <span>{todayDate}</span></li>
                            </ul>
                          </>
                        ) : (
                          <>
                            <ul className="flex list-none align-items-center gap-4">
                              <li><i className="pi pi-user"></i> <span className="author">{sessionData.name}</span></li>
                              <li><i className="pi pi-calendar"></i> <span>{todayDate}</span></li>
                            </ul>
                            <ul className="flex list-none align-items-center gap-4">
                              <li><i className="pi pi-book"></i> <span>{categoryName ?? newsType}</span></li>
                            </ul>
                          </>
                        )}
                      </div>
                      {coverImage && (
                        <PR.Image src={getImageSource(coverImage)} alt="Cover" className="news-img" />
                      )}
                    </div>
                    <div className="col-12 p-0">
                      <div className='content' dangerouslySetInnerHTML={{ __html: dompurifyText(description) }}></div>
                      {files.length > 0 && (
                        <div className='attachments'>
                          <span className='heading-span'>Attached Files:</span>
                          {files?.map((file, index) => (
                            <PR.Button key={index} icon='pi pi-download' label={trimFileName(file.name)} className="download-button" />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <ErrorMessage id={creatNewsError} />
              <div className='text-right mt-4'>
                <PR.Button label="Go back" className="action-buttons mr-2" disabled={loading} onClick={goBack} />
                <PR.Button label="Publish" className="action-buttons save-button" disabled={loading} onClick={handlePublish} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PreviewNews;
